import React, { useEffect, useState } from 'react';
import LocationInput from './LocationInput';
import ButtonSubmit from './ButtonSubmit';
import { FC } from 'react';
import PropertyTypeSelect from './PropertyTypeSelect';
import PriceRangeInput from './PriceRangeInput';
import { getCities, getTypes, getAllProperties } from 'data/DataController';
import ButtonCircle from 'shared/Button/ButtonCircle';
import BtnLikeIcon from 'components/BtnLikeIcon/BtnLikeIcon';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import ButtonThird from 'shared/Button/ButtonThird';
import ButtonSearch from 'shared/Button/ButtonSearch';
import {
  PropertiesContext,
  PropertiesContextProvider,
} from 'context/PropertiesContext';

export type SearchRealEstateTab = 'Both' | 'Buy' | 'Rent';

export interface RealEstateSearchFormProps {
  className?: string;
  currentTab?: SearchRealEstateTab;
  haveDefaultValue?: boolean;
  language?: string;
}

// DEFAULT DATA FOR ARCHIVE PAGE
const defaultLocationValue = 'Plattensee';

const RealEstateSearchForm: FC<RealEstateSearchFormProps> = ({
  className = '',
  currentTab = 'Both',
  haveDefaultValue = false,
}) => {
  const tabs: SearchRealEstateTab[] = ['Both', 'Buy', 'Rent'];
  const [tabActive, setTabActive] = useState<SearchRealEstateTab>(currentTab);
  const [locationInputValue, setLocationInputValue] = useState('');
  const [isLoaded, setIsLoaded] = useState(true);

  const PropertiesContextState = React.useContext(PropertiesContext);

  // Translations
  // const contextState = React.useContext(LanguageContext);
  // const language = contextState.language;
  // const Strings = Languages[language].texts;

  const [language, setLanguage] = useState('en');

  useEffect(() => {
    function getCookie(key: string) {
      var b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
      return b ? b.pop() : '';
    }

    if (!getCookie('siteLang')) {
      setLanguage('en');
    } else {
      /* @ts-ignore */
      setLanguage(getCookie('siteLang'));
      console.log('Site lang cookie is set to: ' + getCookie('siteLang'));
    }
  }, []);

  // Cities
  const [city, setCity] = useState([]);
  const [showCities, setShowCities] = useState(false);
  const [cities, setCities] = useState([]);
  const [cityIds, setCityIds] = useState([]);

  // Zones
  const [zone, setZone] = useState([]);
  const [showZones, setShowZones] = useState(false);
  const [zones, setZones] = useState([]);

  // Types
  const [type, setType] = useState([]);
  const [showTypes, setShowTypes] = useState(false);
  const [types, setTypes] = useState([]);

  // Status
  const [state, setState] = useState([]);
  const [status, setStatus] = useState([]);

  // Conditions
  const [condition, setCondition] = useState([]);
  const [showConditions, setShowConditions] = useState(false);
  const [conditions, setConditions] = useState([]);

  // Bedrooms
  const [bedrooms, setBedrooms] = useState(1);

  // Bathrooms
  const [bathrooms, setBathrooms] = useState(1);

  // Prices
  const [prices, setPrices] = useState([]);

  const [minprice, setMinPrice] = useState(0);
  const [showMinPrice, setShowMinPrice] = useState(false);
  const [maxprice, setMaxPrice] = useState(1000000000);
  const [showMaxPrice, setShowMaxPrice] = useState(false);

  // Area
  const [areas, setAreas] = useState([]);
  const [minarea, setMinArea] = useState([]);
  const [showMinArea, setShowMinArea] = useState(false);
  const [maxarea, setMaxArea] = useState([]);
  const [showMaxArea, setShowMaxArea] = useState(false);

  // Extras
  const [showExtras, setShowExtras] = useState(false);
  const [extras, setExtras] = useState([]);

  // Offers
  const [showOffers, setShowOffers] = useState(false);

  useEffect(() => {
    if (haveDefaultValue) {
      setLocationInputValue(defaultLocationValue);
    }
  }, []);

  const getIdForPropertyTypeSearch = (key: any, array: any) => {
    for (var i = 0; i < array.length; i++) {
      if (array[i].indexOf(key) == 0) {
        console.log('matching---> ');
        console.log(i);
        /* search query for all (both) */
        if (i === 0) {
          return 'any';
        }
        return i;
      }
    }
    return 'any';
  };

  useEffect(() => {
    getCities(language).then((response: any) => {
      //console.log(response);

      // const citySuggestions = response.map(function (item: any) {
      //   return item['title'];
      // });

      const citySuggestions: any = response.map(function (item: any) {
        return { cityId: item['id'], cityName: item['title'] };
      });

      // const cityIdSuggestions = response.map(function (item: any) {
      //   return item['id'];
      // });

      //console.log(citySuggestions);

      setCities(citySuggestions);
      //setCityIds(cityIdSuggestions);

      //console.log(citySuggestions);
    });
  }, []);

  // const searchTermsConst = {
  //   language: language,
  //   city: city[0],
  //   zone: zone,
  //   type: type,
  //   status: status,
  //   condition: condition,
  //   bedrooms: bedrooms,
  //   bathrooms: bathrooms,
  //   minprice: minprice,
  //   maxprice: maxprice,
  //   minarea: minarea,
  //   maxarea: maxarea,
  //   showOffers: showOffers,
  //   extras: extras,
  // };

  useEffect(() => {
    getAllProperties(
      {
        sortby: '',
        page: '',
        ...PropertiesContextState.searchQuery,
        language,
        city,
        zone,
        type,
        status,
        condition,
        bedrooms,
        bathrooms,
        minprice,
        maxprice,
        minarea,
        maxarea,
        showOffers,
        extras,
      }
      // sortby: [],
      // page: 1,
    ).then((response) => {
      console.log('RESP');
      console.log(response);
      PropertiesContextState.setContext({
        results: response,
        searchQuery: {
          ...PropertiesContextState.searchQuery,
          language,
          city,
          zone,
          type,
          status,
          condition,
          bedrooms,
          bathrooms,
          minprice,
          maxprice,
          minarea,
          maxarea,
          showOffers,
          extras,
        },

        // searchTerms: {
        //   ...PropertiesContextState.searchTerms,
        //   language: language,
        //   city: city[0],
        //   zone: zone,
        //   type: type,
        //   status: status,
        //   condition: condition,
        //   bedrooms: bedrooms,
        //   bathrooms: bathrooms,
        //   minprice: minprice,
        //   maxprice: maxprice,
        //   minarea: minarea,
        //   maxarea: maxarea,
        //   showOffers: showOffers,
        //   extras: extras,
        // },

        // searchTerms: {
        //   ...PropertiesContextState.searchTerms,
        //   language,
        //   city,
        //   zone,
        //   type,
        //   status,
        //   condition,
        //   bedrooms,
        //   bathrooms,
        //   minprice,
        //   maxprice,
        //   minarea,
        //   maxarea,
        //   showOffers,
        //   extras,
        // },
      });
      console.log('SeacrcQuery by Searchform set to: ');
      console.log({
        ...PropertiesContextState.searchQuery,
        language,
        city,
        zone,
        type,
        status,
        condition,
        bedrooms,
        bathrooms,
        minprice,
        maxprice,
        minarea,
        maxarea,
        showOffers,
        extras,
      });
    });
  }, []);

  useEffect(() => {
    getTypes(language).then((response: any) => {
      // console.log(response);
      setTypes(response);
    });
  }, []);

  const renderForm = () => {
    return (
      <form className='w-full relative xl:mt-8 flex flex-col lg:flex-row lg:items-center rounded-3xl lg:rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800 divide-y divide-neutral-200 dark:divide-neutral-700 lg:divide-y-0'>
        <LocationInput
          defaultValue={locationInputValue}
          onChangeParent={(e) => {
            // console.log('change parent: ');
            // console.log(e);

            if (e) {
              const choosenCityName = e;
              // console.log('cities: ');
              // console.log(cities);
              // console.log('choosen city name: ');
              // console.log(choosenCityName);
              const choosenCityId: any = cities.filter((cityName) => {
                //console.log(cityName['cityName']);
                return cityName['cityName'] === choosenCityName;
              });
              // console.log('return value: ');
              // console.log(choosenCityId[0]['cityId']);
              if (choosenCityId[0]) {
                setCity(choosenCityId[0]['cityId']);
              }
            } else {
              setCity([]);
            }
            setLocationInputValue(e);
            // @ts-ignore
            //setCity(e);
          }}
          // suggestions={[
          //   'Siófok',
          //   'Hévíz',
          //   'Gödöllő',
          //   'Galgamácsa',
          //   'Budapest',
          //   'Mezőkövesd',
          //   'Eger',
          //   'Miskolc',
          //   'Tatabánya',
          // ]}
          suggestions={cities}
          //suggestionIds={cityIds}
        />
        {types && (
          <PropertyTypeSelect
            types={types}
            onChangeParent={(propertyType: any) => {
              console.log('Selected property type: ');
              console.log(propertyType);
              // console.log(propertyType);
              setType(propertyType);
            }}
          />
        )}

        <PriceRangeInput
          onChangeParent={(priceArray: any) => {
            // console.log('Onchange parent prices: ');
            setMinPrice(priceArray[0] * 1000000);
            setMaxPrice(priceArray[1] * 1000000);
          }}
        />
        {/* BUTTON SUBMIT OF FORM */}

        {/* TODO: not a link but a datacontroller call */}
        <div className='px-4 py-4 lg:py-0'>
          {/* <ButtonSubmit /> */}
          {/* <ButtonCircle
            onClick={() => {
              console.log('Clicked');
            }}
          /> */}
          {/* <BtnLikeIcon
            onPress={() => {
              console.log('Pressed');
            }}
          />
          <ButtonPrimary />
          <ButtonThird /> */}

          <ButtonSearch
            onPress={() => {
              //PropertiesContextState.getProperties();
              //PropertiesContext.Provider.arguments.getProperties();
              // PropertiesContextProvider.arguments.getProperties();
              //PropertiesContextState.setContext('');
              //      PropertiesContextState.getProperties();

              getAllProperties(
                {
                  sortby: '',
                  page: '',
                  ...PropertiesContextState.searchQuery,
                  language,
                  city,
                  zone,
                  type,
                  status,
                  condition,
                  bedrooms,
                  bathrooms,
                  minprice,
                  maxprice,
                  minarea,
                  maxarea,
                  showOffers,
                  extras,
                }
                // sortby: [],
                // page: 1,
              ).then((response) => {
                console.log('RESP');
                console.log(response);
                PropertiesContextState.setContext({
                  results: response,
                  searchQuery: {
                    ...PropertiesContextState.searchQuery,
                    language,
                    city,
                    zone,
                    type,
                    status,
                    condition,
                    bedrooms,
                    bathrooms,
                    minprice,
                    maxprice,
                    minarea,
                    maxarea,
                    showOffers,
                    extras,
                  },
                });
              });
            }}

            //   getAllProperties({
            //     language,
            //     city,
            //     zone,
            //     type,
            //     status,
            //     condition,
            //     bedrooms,
            //     bathrooms,
            //     minprice,
            //     maxprice,
            //     minarea,
            //     maxarea,
            //     showOffers,
            //     extras,
            //     sortby: 'any',
            //     page: 1,
            //     //1
            //   }).then((response) => {
            //     //console.log(response);
            //     console.log('Get proeprties for city: ');
            //     console.log(city);
            //     PropertiesContextState.setContext({
            //       results: response,
            //     });
            //     //setItems(response);
            //     // setSortBy(value);
            //   });
          />
        </div>
      </form>
    );
  };

  const renderTab = () => {
    return (
      <ul className='ml-2 sm:ml-6 md:ml-12 flex space-x-5 sm:space-x-8 lg:space-x-11 overflow-x-auto hiddenScrollbar'>
        {tabs.map((tab) => {
          const active = tab === tabActive;
          return (
            <li
              onClick={() => {
                setTabActive(tab);
                // @ts-ignore
                setStatus(getIdForPropertyTypeSearch(tab, tabs));
              }}
              className={`flex items-center cursor-pointer text-sm lg:text-base font-medium ${
                active
                  ? ''
                  : 'text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-100'
              } `}
              key={tab}
            >
              {active && (
                <span className='block w-2.5 h-2.5 rounded-full bg-neutral-800 dark:bg-neutral-100 mr-2' />
              )}
              <span>{tab}</span>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div
      className={`nc-HeroRealEstateSearchForm w-full max-w-6xl py-5 lg:py-0 ${className}`}
      data-nc-id='HeroRealEstateSearchForm'
    >
      {renderTab()}
      {renderForm()}
    </div>
  );
};

export default RealEstateSearchForm;
